<template>
  <el-dialog
    :visible.sync="visible"
    :modal="false"
    width="50%"
    :close-on-click-modal="false"
    @close="$emit('update:visible', false)"
  >
    <span class="title">客户反馈</span>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="寻访方向" name="1">
        <el-input v-model="project['寻访方向']" size="mini" type="textarea" autosize/>
      </el-collapse-item>
      <el-collapse-item title="目标人选画像" name="2" class="tag-wrapper">
        <el-tag
          v-for="(tag, index) in projectModel['标签']"
          :key="tag"
          closable
          size="small"
          class="mr5 mb5"
          @close="removeProjectTag(index)"
        >{{ tag }}</el-tag>
        <input
          v-if="projectTagInput !== undefined"
          v-model="projectTagInput"
          class="el-tag--small"
          size="mini"
          autofocus="autofocus"
          @keyup.enter.native="confirmAddProjectTag"
          @blur="confirmAddProjectTag"
        >
        <el-button v-else class="button-new-tag" size="mini" @click="projectTagInput = ''">+ 新标签</el-button>
        <div v-for="(tagGroup, i) in tags" :key="i" class="pd-10">
          <div class="project-item-label">{{ tagGroup.label }}</div>
          <el-checkbox-group v-model="projectModel['标签']" class="flex-row flex-wrap">
            <el-checkbox
              v-for="tag in tagGroup.children"
              :key="tag"
              :label="tag"
              class="check-item mr10"
            />
          </el-checkbox-group>
        </div>
        <el-input
          v-model="project.keyWords"
          placeholder="目标人选画像"
          size="mini"
          type="textarea"
          autosize
        />
      </el-collapse-item>
      <el-collapse-item title="面试人选" name="3" class="tag-wrapper">
        <el-tabs v-model="tab">
          <el-tab-pane
            v-for="radish in list"
            :key="radish.rid"
            :label="radish['候选人']"
            :name="radish.rid"
          >
            <div class="flex-row">
              <div class="col-1">
                <p>推荐顾问：{{ selected['顾问'] }}</p>
              </div>
              <div class="col-1">
                <p>
                  <el-radio v-if="selected['结果'] !== '淘汰'" v-model="radio" label="1">通过</el-radio>
                </p>
                <p class="flex-row item-center">
                  <el-radio v-model="radio" class="mr10" label="2">淘汰</el-radio>
                  <el-input v-model="selected['淘汰理由']" size="mini" type="textarea" autosize/>
                </p>
              </div>
            </div>
            <div class="note">
              <p>客户反馈</p>
              <el-input
                v-model="selected['客户备注']"
                placeholder="客户反馈"
                size="mini"
                type="textarea"
                autosize
              />
            </div>
            <div v-for="(_tagGroup, _i) in feedbackTags" :key="_i" class="pd-10">
              <div>{{ _tagGroup.label }}</div>
              <!-- <div v-if="_tagGroup.key === 'other'">
                <el-tag
                  v-for="_tag in _tagGroup.checkList"
                  :key="_tag"
                  closable
                  size="small"
                  @close="removeTag(_tag, 'feedbackTags')"
                >{{ _tag }}</el-tag>
                <el-input
                  v-if="inputVisible === 'radish'"
                  ref="saveTagInput"
                  v-model="inputValue"
                  class="input-new-tag"
                  size="small"
                  @keyup.enter.native="handleInputConfirm('feedbackTags')"
                  @blur="handleInputConfirm('feedbackTags')"
                />
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  @click="showInput('radish')"
                >+ New Tag</el-button>
              </div>-->
              <el-checkbox-group v-model="_tagGroup.checkList" class="flex-row flex-wrap">
                <el-checkbox
                  v-for="_tag in _tagGroup.children"
                  :key="_tag"
                  :label="_tag"
                  class="check-item mr10"
                />
              </el-checkbox-group>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
    </el-collapse>
    <div slot="footer" class="dialog-footer">
      <span class="mr10">
        <el-button size="mini" @click="$emit('update:visible', false)">取 消</el-button>
      </span>
      <el-button type="primary" size="mini" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { projectModel } from '../model'
import { tags } from '../constant/type'

export default {
  mixins: [projectModel],
  props: {
    visible: { type: Boolean, default: false },
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      list: [],
      feedbackTags: [],
      activeNames: ['1', '2', '3'],
      radio: '1',
      tab: '',
      // inputVisible: undefined,
      // inputValue: '',
      selected: {},
      projectTagInput: undefined,
    }
  },
  computed: {
    tags() {
      return tags
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (!val || val === oldVal) return
        this.getRadish(val)
      },
      immediate: true,
    },
    visible: {
      async handler(val, oldVal) {
        if (!val) return
        const project = this.project
        this.fetchProject(project._id)
        this.list = await app.service('project').projectInterviews(project._id)
        if (this.list.length === 0) return
        this.tab = (this.list[0] && this.list[0].rid) || ''
      },
      immediate: true,
    },
  },
  methods: {
    parseTags(data = {}) {
      const result = _.cloneDeep(tags)
      result.map(tagGroup => {
        tagGroup.checkList = data[tagGroup.key] || []
      })
      return result
    },
    // removeTag(tag, field) {
    //   const _tags = this[field]
    //   _tags.map(tagGroup => {
    //     if (tagGroup.key === 'other') {
    //       const children = tagGroup.children
    //       children.splice(children.indexOf(tag), 1)
    //     }
    //   })
    // },
    // showInput(index) {
    //   this.inputVisible = index
    //   this.$nextTick(_ => {
    //     this.$refs.saveTagInput && this.$refs.saveTagInput[0].$refs.input.focus()
    //   })
    // },
    // handleInputConfirm(field) {
    //   const inputValue = this.inputValue
    //   if (inputValue) {
    //     const _tags = this[field]
    //     _tags.map(tagGroup => {
    //       if (tagGroup.key === 'other') {
    //         tagGroup.checkList.push(inputValue)
    //       }
    //     })
    //   }
    //   this.inputVisible = undefined
    //   this.inputValue = ''
    // },
    async getRadish(rid) {
      if (rid === '0') return
      try {
        const list = this.list
        const data = list.find(val => val.rid === rid)
        this.feedbackTags = this.parseTags(data['客户反馈'])
        this.selected = Object.assign({}, data)
        data['结果'] === '淘汰' ? (this.radio = '2') : (this.radio = '1')
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async save() {
      const { feedbackTags, projectModel, radio, selected } = this
      this.updateProject({
        id: projectModel._id,
        param: {
          标签: projectModel['标签'],
          寻访方向: projectModel['寻访方向'],
          keyWords: projectModel.keyWords,
        },
      })

      if (radio === '2') {
        app.service('radish').eliminate({
          rid: selected.rid,
          pid: projectModel._id,
          reason: selected['淘汰理由'],
        })
      }
      const radishParam = {}
      feedbackTags.map(tagGroup => {
        radishParam[tagGroup.key] = tagGroup.checkList
      })
      app.service('radish').modifyInterview({
        _id: selected._id,
        data: {
          客户反馈: radishParam,
          客户备注: selected['客户备注'],
        },
      })

      this.$emit('update:visible', false)
    },
    async modifyProject(param) {
      this.loading = true
      try {
        await window.app.service('project').modify({ id: this.project._id, param })
        app.root.$refs.main.$refs.projectTable && app.root.$refs.main.$refs.projectTable.getProjects()
        this.$message({ type: 'success', message: '保存成功' })
        this.editing = false
      } catch (error) {
        this.$message.error(`project modify:${error.message}`)
      }
      this.loading = false
    },
    confirmAddProjectTag() {
      this.addProjectTag(this.projectTagInput)
      this.projectTagInput = undefined
    },
  },
}
</script>

<style scoped>
.diy-input {
  border-radius: 4px;
  padding: 2px 5px;
  border: 1px solid #dcdfe6;
}
.title {
  text-align: center;
  font-size: 18px;
  position: absolute;
  left: 0;
  right: 0;
  top: 24px;
  width: 60%;
  margin: auto;
  display: inline-block;
}
</style>
